module.exports = __webpack_public_path__ + "img/IMG_8155_L_WoodMatted.9ccebd4d.jpg";